import React,{useEffect,useState} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {useAuth} from '@/contexts/AuthContext.jsx';
import supabase from '@/services/supabaseClient.js';
import {useLanguage} from '@/contexts/LanguageContext.jsx';
import {readOrganisationEvidence} from '@/lib/organisationAdmissionEvidence.mjs';
const project='https://nwgxdrldipcuyxupaqit.supabase.co';
// Never write clinical role metadata or accept cached/email-only branch hints.
export default function ProductionOrganisationAdmission({lane,children}){
 const {user}=useAuth()||{},subject=user?.id||'',{pathname}=useLocation();
 const {languageCode}=useLanguage(),fr=String(languageCode).startsWith('fr');
 const key=JSON.stringify([subject,lane,pathname]);
 const [state,setState]=useState(null);
 useEffect(()=>{
  let mounted=true,revision=0;
  async function refresh(){
   const current=++revision;setState({key,status:'PENDING'});
   if(!subject){setState({key,status:'DENIED'});return;}
   try{
    const proof=await readOrganisationEvidence(supabase,subject,{expectedProjectUrl:project});
    if(mounted&&current===revision)setState({key,status:proof.status,proof});
   }catch{if(mounted&&current===revision)setState({key,status:'HOLD'});}
  }
  const visible=()=>{if(document.visibilityState==='visible')refresh();};
  refresh();window.addEventListener('focus',refresh);document.addEventListener('visibilitychange',visible);
  return()=>{mounted=false;revision++;window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',visible);};
 },[key,subject]);
 const fresh=state?.key===key&&state.status==='READ_AUTHORITY_IDENTIFIED'&&state.proof?.project_url===project&&state.proof?.subject===subject;
 const allowed=fresh&&(lane==='pharmacy'?Boolean(state.proof.pharmacy):lane==='institution'&&state.proof.institutions.length>0);
 if(allowed)return children;
 const pending=Boolean(subject)&&(!state||state.key!==key||state.status==='PENDING');
 return <main className="min-h-[100dvh] grid place-items-center bg-background px-6 text-center"><section className="max-w-md space-y-4">
  <h1 className="text-title-large">{fr?'Accès AfriMed™':'AfriMed™ access'}</h1>
  <p role="status">{pending?(fr?'Vérification de votre accès à l’organisation…':'Checking your existing organisation access…'):(fr?'Votre accès à l’organisation ne peut pas encore être confirmé. Veuillez contacter l’assistance.':'Your organisation access could not yet be confirmed. Please contact support.')}</p>
  {!subject&&<Link to="/login" className="text-primary">{fr?'Se connecter':'Sign in'}</Link>}
 </section></main>;
}
